import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { faFilter } from "../../../../../helpers/icons/fontAwesomeIcons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import classes from "./FeatureFilterButton.module.scss";

const FeatureFilterButton = ({ t, filterContent }) => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <>
      <Button 
        className={classes["feature-filter-button"]} 
        onClick={handleShow}
        title={t("filter")}
        variant="outline-light"
      >
        <FontAwesomeIcon icon={faFilter} />
      </Button>

      <Modal 
        show={showModal} 
        onHide={handleClose} 
        centered
        className={classes["feature-filter-modal"]}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("filters")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {filterContent}
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("resetFilters")}
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            {t("cancel")}
          </Button>
          <Button variant="primary" onClick={handleClose}>
            {t("applyFilters")}
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};

FeatureFilterButton.propTypes = {
  t: PropTypes.func.isRequired,
  filterContent: PropTypes.node.isRequired
};

export default FeatureFilterButton;